const extraServices = {
  header: {
    btnCreate: 'Criar',
  },

  toast: {
    error: {
      badResponse: '[Extra Service] resposta inválida do servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Extra Service] criado com sucesso',
      },
      edit: {},
      delete: {
        default: '[Extra Service] excluído com sucesso',
      },
    },
  },

  deleteModal: {
    header: 'Excluir serviços extras',
    body: 'Você está prestes a excluir {{num}} serviços extras.',
  },

  table: {
    filters: {
      profileType: 'Tipo de Perfil'
    },
    headers: {
      name: 'Serviço extra',
      profileType: 'Tipo de Perfil',
      basePrice: 'Base',
      extraPrice: 'Cada Extra',
      baseUpTo: 'Baseie até',
      surcharge: 'Sobretaxa',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
  },

  create: {
    successToast: {
      message: 'sucesso! Serviço extra criado',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível criar um serviço extra',
    },
  },

  edit: {
    successToast: {
      message: 'sucesso! Serviço extra atualizado',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível atualizar o serviço extra',
    },
  },

  forms: {
    header: {
      createExtraService: {
        title: 'Criar',
      },

      updateExtraService: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalhes',
        fields: {
          name: 'Serviço extra',
          profileType: 'Tipo de Perfil',
          description: 'Descrição',
          profileTypeOptions: {
            retail: 'Varejo',
            individual: 'Pessoal',
            wholesale: 'Atacado',
            corporate: 'Corporativa',
            website: 'Web site',
            hotel: 'Hotel',
            thirdParty: 'Terceiros',
            tourOperator: 'Operador de Viagem',
            receiptiveOperator: 'Operador Receptivo',
          },
        },
      },
      settings: {
        header: 'Configurações',
        fields: {
          basePrice: 'Base',
          extraPrice: 'Cada Extra',
          baseUpTo: 'Baseie até',
          surcharge: 'Sobretaxa',
        },
      },
    },
  },
};

export default extraServices;
